<template>
  <footer class="footer">
    <div class="footer-tabs-container">
      <div class="footer-tab about-us">
        <router-link :to="handlePath(0, 0)">关于我们</router-link>
        <span class="tab-icon"><img src="../../assets/images/footer/icon_01.png" alt="关于我们" /></span>
      </div>
      <div class="footer-tab notice">
        <router-link :to="handlePath(1, 0)">通知公告</router-link>
        <span class="tab-icon"><img src="../../assets/images/footer/icon_02.png" alt="通知公告" /></span>
      </div>
      <div class="footer-tab help-center">
        <router-link :to="handlePath(2, 0)">帮助中心</router-link>
        <span class="tab-icon"><img src="../../assets/images/footer/icon_03.png" alt="帮助中心" /></span>
      </div>
    </div>

    <div class="footer-content-area">
      <div class="footer-main">
        <div class="footer-col">
          <ul>
            <li><router-link :to="handlePath(0, 1)">机构简介</router-link></li>
            <li><router-link :to="handlePath(0, 2)">联系我们</router-link></li>
            <li><router-link :to="handlePath(0, 3)">合作意向</router-link></li>
          </ul>
        </div>
        <div class="footer-col">
          <ul>
            <li><router-link :to="handlePath(1, 1)">集采公告</router-link></li>
            <li><router-link :to="handlePath(1, 2)">中标公告</router-link></li>
            <li><router-link :to="handlePath(1, 3)">其他公告</router-link></li>
          </ul>
        </div>
        <div class="footer-col">
          <ul>
            <li><router-link :to="handlePath(2, 1)">交易流程</router-link></li>
            <li><router-link :to="handlePath(2, 2)">交易须知</router-link></li>
            <li><router-link :to="handlePath(2, 3)">常见问题</router-link></li>
            <li><router-link :to="handlePath(2, 4)">法律声明</router-link></li>
          </ul>
        </div>
        <div class="footer-qrcode-col">
          <!-- <div class="qrcode-item">
            <span>官方微信</span>
            <img src="../../assets/images/home/right_code_01.png" alt="官方微信二维码" class="footer-qrcode" />

          </div>
          <div class="qrcode-item">
            <span>官方二维码</span>
            <img src="../../assets/images/home/right_code_03.jpg" alt="官方APP下载二维码" class="footer-qrcode" />
          </div> -->
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-contact">
        <div class="footer-contact-col">
          <span>邮箱：hngs-jsjt@hihec.cn</span>
          <span>传真：0898-66755700</span>
        </div>
        <div class="footer-contact-col">
          <span>电话：0898-66755700</span>
          <span>地址：海口市美兰区蓝天路16号金银岛大酒店副楼（超凡大厦）五楼</span>
        </div>
      </div>
      <div class="footer-copyright">
        <span>海南高速公路工程建设集团有限公司 版权所有</span>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">琼ICP备18020762号</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      // 数据结构已整合到模板中，此处保留备用
    }
  },
  methods: {
    handlePath(index, i) {
      let query =  {type: i}
      if(i > 0) {
        query =  {type: i - 1}
      }
      let path = this.$route.path
      if(index == 0) {
        return {path: '/layout/aboutUs',query}
      } else if(index == 1) {
        query = {type: i}
        return {path: '/layout/notice', query}
      } else if(index == 2){
        return {path: '/layout/helpCenter', query}
      }
    }
  }
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  min-height: 4.91rem;
  color: #fff;
  font-size: 14px;
  position: relative;
  overflow: hidden;
  // 使用纯色背景替代图片，因为图片可能不存在
  background-image: url("../../assets/images/footer/footer_bg.png");
}

.footer-tabs-container {
  display: flex;
  justify-content: flex-start;
  gap: 0.1rem;
  width: calc(100% - 1.64rem);
  margin: 0.61rem 0.87rem 0.19rem 0.87rem;
  position: relative;
  z-index: 2;
  height: 0.5rem;
  width: 9.53rem;
  line-height: 0.5rem;
}

.footer-tab {
  color: white !important;
  padding: 0 20px;
  border-radius: 0;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.25rem;
  cursor: pointer;
  margin-right: 2px;
  width: 3.11rem;
  height: 0.5rem;
  // flex-shrink: 0;
  // box-sizing: border-box;

  &:last-child {
    margin-right: 0;
  }

  &.about-us {
    background-color: #feb23d;
  }

  &.notice {
    background-color: #fb9900;
  }

  &.help-center {
    background-color: #ed8000;
  }

  .tab-icon {
    display: inline-flex;
    align-items: center;

    img {
      width: 0.23rem;
      height: 0.23rem;
    }
  }

  a {
    color: white !important;
    text-decoration: none;

    &:hover {
      color: white !important;
    }
  }
}

.footer-content-area {
  width: calc(100% - 1.74rem);
  height: 2.16rem;
  margin: 0 0.87rem 0.19rem 0.87rem;
  position: relative;
  border-radius: 0;
  background-color: rgba(255, 255, 255, 0.25);
  // opacity: 0.25;
  z-index: 1;

  a {
    color:#000000 !important;
    text-decoration: none;

    &:hover {
      color: #103A6E !important;
    }
  }
}

.footer-main {
  display: flex;
  justify-content: flex-start;
  height: 100%;
  gap: 2.3rem;
  margin-left: 0.6rem;
  padding-top: 0.38rem;
  // padding: 0 0.1rem;
}

.footer-col {
  min-width: 1rem;
  display: flex;
  align-items: top;
}

.footer-col:last-child {
  flex: 0 0 120px;
  margin-left: 30px;
}

.footer-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-col li {
  margin-bottom: 10px;
  color: #000000;
  font-size: 0.2rem;
  font-family: AlibabaPuHuiTiR;
  line-height: 1.5;

  &:hover {
    color: #ff8c00;
  }
}

.footer-qrcode-col {
  display: flex;
  gap: 0.2rem;
  justify-content: flex-end;
  align-items: right;
  margin-left: 4rem;
}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;

  span {
    margin-top: 8px;
    font-size: 13px;
    color: #103A6E;
  }
}

.footer-qrcode {
  width: 0.87rem;
  height: 0.87rem;
  background-color: #fff !important;
  padding: 4px;
  display: block;
}

.footer-bottom {
  color: #ffffff;
  font-family: AlibabaPuHuiTiR;
	font-size: 0.14rem;
  display: flex;
  margin: 0 0.87rem 0.19rem 0.87rem;
  justify-content: space-between;
  align-items: center;

  // flex-direction: column;
  // justify-content: center;
}

.footer-contact {
  display: flex;
  justify-content: space-between;
  width: 6.32rem;
}

.footer-contact-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-copyright {
  text-align: right;
  width: 5.32rem;

  span {
    display: inline-block;
    margin-right: 0.1rem;
  }

  a {
    color: rgba(255, 255, 255, 1);
    text-decoration: none;

    &:hover {
      color: #fff;
      text-decoration: underline;
    }
  }
}

@media screen and (max-width: 1024px) {
  .footer-tabs-container {
    justify-content: flex-start;
    overflow-x: auto;
    padding-left: 15px;
    padding-right: 15px;
  }

  .footer-tab {
    padding: 0 15px;
    font-size: 14px;
  }

  .footer-main {
    flex-wrap: wrap;
    gap: 20px;
  }

  .footer-col {
    flex-basis: 45%;
    min-width: 180px;
  }

  .footer-col:last-child {
    flex-basis: 100%;
    margin-left: 0;
    justify-content: center;
  }

  .footer-contact {
    flex-basis: auto;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 100%;
  }

  .footer-contact-col {
    align-items: center;
  }

  .footer-copyright {
    flex-basis: auto;
    text-align: center;
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .footer-tab {
    font-size: 13px;
    padding: 0 12px;
    gap: 6px;

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .footer-content-area {
    padding: 0.1rem;
  }

  .footer-main {
    flex-direction: column;
    align-items: center;
    gap: 25px;
    padding: 0.2rem;
  }

  .footer-col {
    width: 100%;
    text-align: center;
    flex-basis: auto;
  }

  .footer-col ul {
    align-items: center;
  }

  .footer-qrcode-col {
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  .footer-bottom {
    padding-top: 15px;
    padding-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue